import React, { Component } from 'react';
import { DatePicker as DatepickerAntd } from 'antd';
import CalendarLocale from 'rc-calendar/lib/locale/pt_BR';
import TimePickerLocale from '../TimePicker/Locale';

// Merge into a locale object
const locale = {
  lang: {
    placeholder: 'Selecionar data',
    rangePlaceholder: ['Data de início', 'Data de fim'],
    ...CalendarLocale,
  },
  timePickerLocale: {
    ...TimePickerLocale,
  },
};

// O primeiro formato é o exibido; os demais também são aceitos ao digitar
// (o antd valida o texto digitado no formato exato, sem tolerância).
const DATE_FORMATS = ['DD/MM/YYYY', 'DDMMYYYY', 'DD/MM/YY', 'DDMMYY'];
const DATE_TIME_FORMATS = ['DD/MM/YYYY HH:mm', 'DDMMYYYY HHmm', 'DD/MM/YY HH:mm'];

export class DatePicker extends Component {
  render() {
    const { props } = this;
    return (
      <DatepickerAntd 
        placeholder="Selecione uma data"
        style={{ width: '100%' }}
        locale={locale}
        format={props.showTime ? DATE_TIME_FORMATS : DATE_FORMATS}
        getPopupContainer={trigger => trigger.parentNode}
        dropdownClassName="date-picker-typeable"
        {...props}
      />
    )
  }
}

export default locale;